module.exports = __webpack_public_path__ + "static/media/bankserv.7732fcae.jpg";